import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@material-ui/core';

// Material icons
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';

// Shared utilities
import validators from 'common/validators';

// Component styles
import styles from './styles';

// Form validation schema
import {mainSchema} from './schema';
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";

validate.validators.checked = validators.checked;

class SignUp extends Component {
  state = {
    values: {
      name: '',
      email: '',
      confirmEmail: '',
      password: '',
      confirmPassword: '',
    },
    touched: {
      name: false,
      email: false,
      confirmEmail: false,
      password: false,
      confirmPassword: false,
    },
    errors: {
      name: null,
      email: null,
      confirmEmail: null,
      password: null,
      confirmPassword: null,
    },
    isValid: false,
    openDialog: ''
  };

  handleBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;
    const newState = { ...this.state };
    let errors = validate(values, mainSchema);
    console.log(errors);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.submitError = null;
    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  handleSignUp = async () => {
    try {
      const { values } = this.state;
      this.setState({ isLoading: true });
      let userData = {
        username: values.name,
        email: values.email,
        password: values.password,
      };
      await this.props.registerUser(userData);
      this.setState({openDialog:'success'});
      
    } catch (error) {
      console.error(error);
    }
  };

  handleClose = () => {
    const { history } = this.props;
    this.setState({openDialog:''});
    history.push('/sign-in');
  }

  renderSuccessDialog() {
    const {openDialog} = this.state;
    return (
      <Dialog
        open={openDialog==='success'}
        onClose={this.handleClose}
      >
        <DialogTitle id="register-success-dialog">Check Your Email To Activate Your Account</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Successfully sign up!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  render() {
    const { classes } = this.props;
    const {
      values,
      touched,
      errors,
      isValid,
    } = this.state;

    const {loading} = this.props.auth;

    const showNameError =
      touched.name && errors.name ? errors.name[0] : false;
    const showEmailError =
      touched.email && errors.email ? errors.email[0] : false;
    const showConfirmEmailError =
      touched.confirmEmail && errors.confirmEmail ? errors.confirmEmail[0] : false;
    const showPasswordError =
      touched.password && errors.password ? errors.password[0] : false;
    const showConfirmPasswordError =
      touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword[0] : false;

    return (
      <div className={classes.root}>
        {this.renderSuccessDialog()}
        <Grid
          className={classes.grid}
          container
        >
          <Grid
            className={classes.quoteWrapper}
            item
            lg={5}
          >
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography
                  className={classes.quoteText}
                  variant="h1"
                  gutterBottom
                >
                  Industry Proven Client Video Solutions for All Platforms
                </Typography>
                <div className={classes.person}>
                  <Typography
                    className={classes.name}
                    variant="body1"
                  >
                    © 2021 VisualOn Inc 
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid
            className={classes.content}
            item
            lg={7}
            xs={12}
          >
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton
                  className={classes.backButton}
                  onClick={this.handleBack}
                >
                  <ArrowBackIcon />
                </IconButton>
              </div>
              <div className={classes.contentBody}>
                <form className={classes.form}>
                  <Typography
                    className={classes.title}
                    variant="h2"
                  >
                    Create new account
                  </Typography>
                  <div className={classes.fields}>
                    <TextField
                      required
                      className={classes.textField}
                      label="Email address"
                      name="email"
                      onChange={event =>
                        this.handleFieldChange('email', event.target.value)
                      }
                      value={values.email}
                      variant="outlined"
                    />
                    {showEmailError && (
                      <Typography
                        className={classes.fieldError}
                        variant="body2"
                      >
                        {errors.email[0]}
                      </Typography>
                    )}
                    <TextField
                      required
                      className={classes.textField}
                      label="Confirm Email address"
                      onChange={event =>
                        this.handleFieldChange('confirmEmail', event.target.value)
                      }
                      value={values.confirmEmail}
                      variant="outlined"
                    />
                    {showConfirmEmailError && (
                      <Typography
                        className={classes.fieldError}
                        variant="body2"
                      >
                        {errors.confirmEmail[0]}
                      </Typography>
                    )}
                    <TextField
                      required
                      className={classes.textField}
                      label="Password"
                      onChange={event =>
                        this.handleFieldChange('password', event.target.value)
                      }
                      type="password"
                      value={values.password}
                      variant="outlined"
                    />
                    {showPasswordError && (
                      <Typography
                        className={classes.fieldError}
                        variant="body2"
                      >
                        {errors.password[0]}
                      </Typography>
                    )}
                    <TextField
                      required
                      className={classes.textField}
                      label="Confirm Password"
                      onChange={event =>
                        this.handleFieldChange('confirmPassword', event.target.value)
                      }
                      type="password"
                      value={values.confirmPassword}
                      variant="outlined"
                    />
                    {showConfirmPasswordError && (
                      <Typography
                        className={classes.fieldError}
                        variant="body2"
                      >
                        {errors.confirmPassword[0]}
                      </Typography>
                    )}
                    <TextField
                      required
                      className={classes.textField}
                      label="Name"
                      name="name"
                      onChange={event =>
                        this.handleFieldChange('name', event.target.value)
                      }
                      value={values.name}
                      variant="outlined"
                    />
                    {showNameError && (
                      <Typography
                        className={classes.fieldError}
                        variant="body2"
                      >
                        {errors.name[0]}
                      </Typography>
                    )}
                  </div>
                  {loading ? (
                    <CircularProgress className={classes.progress} />
                  ) : (
                    <Button
                      className={classes.signUpButton}
                      color="primary"
                      disabled={!isValid}
                      onClick={this.handleSignUp}
                      size="large"
                      variant="contained"
                    >
                      Sign up now
                    </Button>
                  )}
                  <Typography
                    className={classes.signIn}
                    variant="body1"
                  >
                    Have an account?{' '}
                    <Link
                      className={classes.signInUrl}
                      to="/sign-in"
                    >
                      Sign In
                    </Link>
                  </Typography>
                </form>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

SignUp.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, {registerUser})
)(SignUp);
